// LandingPage.jsx — root component
// Stack: React + Tailwind CSS + @mui/icons-material
//
// tailwind.config.js  →  see syncmama/tailwind.config.js
// global styles       →  import './globals.css' in your app entry (main.jsx / index.js)
//
// Required packages:
//   npm install @mui/icons-material @mui/material @emotion/react @emotion/styled

import React, { useEffect } from "react";
import { useTheme } from "../../contexts/theme-context";
import { useLocation } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
import ParticleCanvas   from "./components/ParticleCanvas";
import Nav              from "./components/Nav";
import Hero             from "./components/Hero";
import StudiosCarousel  from "./components/StudiosCarousel";
import MoviesCarousel   from "./components/MoviesCarousel";
import SearchSection    from "./components/SearchSection";
import LanguageSection  from "./components/LanguageSection";
import LicenceSection   from "./components/LicenceSection";
import PricingSection   from "./components/PricingSection";
import UseCasesSection  from "./components/UseCasesSection";
import FinalCTA         from "./components/FinalCTA";
import Footer           from "./components/Footer";
import SilkRoadSection from "./components/SilkRoadSection";

// import './style.css'

export default function LandingPage() {
  const { theme, toggleTheme } = useTheme();
  const dark = theme === "dark";
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.hash]);

  const toggleDark = toggleTheme;

  return (
    
    // 'dark' class on root enables Tailwind dark: variants throughout the tree
    <div className="" id="">
    <div className={dark ? "dark" : ""}>
      {/* <Helmet>
        <title>SyncMama — Licensed Production Music India | AI Search | 1M+ Tracks</title>
        <meta name="description" content="License world-class production music instantly. 1M+ tracks. AI search in Hindi, Tamil, Telugu & more. Perpetual worldwide licence. 1 month free." />
        <meta property="og:title" content="SyncMama — Licensed Production Music India" />
        <meta property="og:description" content="1M+ tracks. AI search in every Indian language. Perpetual worldwide licence." />
        <meta property="og:url" content="https://syncmama.com" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://syncmama.com" />
      </Helmet> */}
      <div className="
        relative min-h-screen overflow-x-hidden
        bg-white dark:bg-[#0d1117]
        text-[#1a2540] dark:text-[#e6edf3]
        font-dm
        pt-4
      " style={{background : "rgb(var(--canvas))"}}>
        {/* <ParticleCanvas /> */}

        <Nav dark={dark} onToggleDark={toggleDark} />

        <main style={{background : "rgb(var(--canvas))"}}>
          <Hero />
          <FinalCTA />
          <StudiosCarousel />
          <MoviesCarousel />
          <SearchSection />
          <LanguageSection />
          <LicenceSection />
          <PricingSection />
          <UseCasesSection />
          <FinalCTA />
          <SilkRoadSection />
        </main>

        <Footer />
      </div>
    </div>
    </div>
  );
}
